/**
 * Map name for mutations
 * @types {string}
 */
export const SET_PARAM = "VIEWS/SET_PARAM";
export const SET_MISSION_MENU = "VIEWS/SET_MISSION_MENU";
export const SET_ALCADAS = "VIEWS/SET_ALCADAS";
